import config from "@/config";

export const LOCAL_DOMAIN_STORAGE_KEY = "local_domain";

/**
 * Hosts that act as a single, shared login entry point (e.g. `gomake.net`). On these
 * hosts a user logs in, picks a print house, and stays on the SAME host instead of being
 * handed off to that print house's own domain. Per-print-house domains keep working.
 * Configurable via `SHARED_LOGIN_DOMAINS` (comma-separated); `gomake.net` is always included.
 */
export const getSharedLoginDomains = (): string[] => {
  const fromConfig = String(config?.shared_login_domains || "").split(",");
  return Array.from(
    new Set(
      [...fromConfig, "gomake.net"]
        .map((d) => d.trim().toLowerCase())
        .filter(Boolean)
    )
  );
};

export const isSharedLoginDomain = (host?: string): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  const hostname = (host ?? window.location.hostname).toLowerCase();
  return getSharedLoginDomains().includes(hostname);
};

export const isLocalDomainFeatureEnabled = (): boolean => {
  if (process.env.ENVIRONMENT === "production") {
    return false;
  }
  if (typeof window === "undefined") {
    return false;
  }
  const hostname = window.location.hostname;
  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "::1"
  );
};

export const getLocalDomainHeader = (): string => {
  if (!isLocalDomainFeatureEnabled()) {
    return "";
  }
  return localStorage.getItem(LOCAL_DOMAIN_STORAGE_KEY) || "";
};
